import GLightbox from 'glightbox';

export const initGalleryLightbox = () => {
  if (!document.querySelector('.glightbox')) return;

  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
  });
};
